<template>
  <div>
    <div v-if="!loaded" class="preloader-overlay">
      <div class="preloader-card">
        <f7-preloader></f7-preloader>
        <div class="preloader-text">
          {{ $t('loading') }}
        </div>
      </div>
    </div>
    <div class="summary-header">
      <div class="summary-title">
        <div class="summary-icon-complaints"></div>
        <div class="summary-text">
          {{ $t('complaintManagement') }}
        </div>
      </div>
    </div>
    <DxDataGrid
      :data-source="filteredIssues"
      :show-borders="false"
      :show-column-lines="false"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-auto-width="true"
      :show-column-headers="true"
      :show-colon="false"
      :remote-operations="true"
      :load-panel="{ enabled: false }"
      :hover-state-enabled="false"
      :show-row-lines="false"
      :row-alternation-enabled="false"
      :no-data-text="$t('noDataText')"
      class="custom-grid custom-complaint-Management"
      @content-ready="init"
      @toolbar-preparing="onToolbarPreparing($event)"
    >
      <DxScrolling mode="standard" />

      <DxSearchPanel
        :visible="true"
        :width="300"
        :placeholder="$t('search')"
      />

      <DxStateStoring
        :enabled="true"
        type="custom"
        storage-key="ComplaintsTable"
        :custom-load="loadState"
        :custom-save="customSave"
      />

      <DxPaging :page-size="5" />

      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="[5, 10, 20]"
        :show-info="true"
        info-text="{2} items"
        :visible="true"
      />

      <!-- <DxColumn
        data-field="color"
        header-cell-template="cellTemplateHeaderDots"
        :width="55"
        :allow-sorting="true"
        cell-template="cellTemplateDots"
        :fixed="true"
        fixed-position="left"
      /> -->

      <DxColumn
        data-field="title"
        :caption="$t('complaintCode')"
        :allow-sorting="true"
        :fixed="true"
        fixed-position="left"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="translatedOrigin"
        :caption="$t('origin')"
        :allow-sorting="true"
        :fixed="true"
        fixed-position="left"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="nombreContacto"
        :caption="$t('complaintRequester')"
        :allow-sorting="true"
        :fixed="true"
        fixed-position="left"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="translatedColorStatus"
        :caption="$t('status')"
        :allow-sorting="true"
        :fixed="true"
        alignment="center"
        fixed-position="left"
        :allow-header-filtering="false"
        cell-template="cellTemplateColorStatus"
      />

      <DxColumn
        data-field="created"
        :caption="$t('date')"
        :allow-sorting="true"
        sort-order="desc"
        :sort-index="0"
        data-type="date"
        :format="$helpers.getDateFormat(company)"
        :fixed="true"
        alignment="center"
        fixed-position="left"
        :allow-header-filtering="false"
      />

      <DxColumn
        :buttons="updatedEditButtons"
        :fixed="true"
        fixed-position="right"
        type="buttons"
        width="80"
        name="actionColumn"
      />

      <!-- Leyenda del estado por colores -->
      <template #cellTemplateColorStatus="{ data }">
        <div
          :class="getComplaintStatusClass(data.data)"
          class="status-text"
          style="text-align: center"
        >
          {{ data.data.translatedColorStatus }}
        </div>
      </template>
      <!-- Leyenda del semáforo de colores -->
      <template #cellTemplateHeaderDots>
        <div>
          <PopUp position="top">
            <div style="padding: 10px">
              <div class="pop-up-info">
                <span
                  class="complaint-status-dot complaint-status-dot--green"
                ></span>
                <div style="padding-left: 5px">
                  {{
                    $t(
                      'complaintManagementLegend.greenDotDescription'
                    )
                  }}
                </div>
              </div>
              <div class="pop-up-info">
                <span
                  class="complaint-status-dot complaint-status-dot--blue"
                ></span>
                <div style="padding-left: 5px">
                  {{
                    $t('complaintManagementLegend.blueDotDescription')
                  }}
                </div>
              </div>
              <div class="pop-up-info">
                <span
                  class="complaint-status-dot complaint-status-dot--orange"
                ></span>
                <div style="padding-left: 5px">
                  {{
                    $t(
                      'complaintManagementLegend.orangeDotDescription'
                    )
                  }}
                </div>
              </div>
            </div>
          </PopUp>
        </div>
      </template>
      <template #cellTemplateDots="{ data }">
        <div class="dots-parent-container">
          <span
            v-if="getComplaintStatusTone(data.data) !== 'grey'"
            class="complaint-status-dot"
            :class="`complaint-status-dot--${getComplaintStatusTone(
              data.data
            )}`"
          ></span>
        </div>
      </template>
    </DxDataGrid>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxSearchPanel,
  DxStateStoring,
  DxPager,
  DxPaging,
  DxScrolling,
} from 'devextreme-vue/data-grid';
import { mapState, mapActions } from 'vuex';
import PopUp from '@/components/UtilityComponents/popUpInfo/popUp.vue';
import iconVisibility from '@/static/icons/ic_visibility.svg';
import { hasComplaintRegisterAccess } from '@/js/routeAccess';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxSearchPanel,
    DxStateStoring,
    DxPager,
    DxPaging,
    DxScrolling,
    PopUp,
  },
  props: {
    store: {
      type: Array,
      default: () => [],
    },
    initialStatus: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      editButtons: [
        {
          icon: 'find',
          onClick: this.viewAtc,
        },
      ],
      selectedStatuses: [],
      filteredIssues: [],
      loaded: false,
    };
  },
  computed: {
    updatedEditButtons() {
      return [
        {
          icon: iconVisibility,
          onClick: this.viewAtc,
          cssClass: 'grid-button-icon',
        },
      ];
    },
    canRegisterComplaints() {
      return hasComplaintRegisterAccess({
        enabled: this.enabled,
        authenticatedUser: this.authenticatedUser,
        company: this.company,
      });
    },
    ...mapState('contact', ['company', 'enabled']),
    ...mapState('user', ['authenticatedUser']),
    ...mapState('complaintManagement', ['complaintDetails']),
  },
  watch: {
    initialStatus: {
      immediate: true,
      handler() {
        this.applyInitialStatusFilter();
      },
    },
    store: {
      immediate: true,
      deep: true,
      handler() {
        this.updateIssuesFilter();
      },
    },
  },
  methods: {
    applyInitialStatusFilter() {
      const statusColorMap = {
        pending_action: 'orange',
        in_progress: 'blue',
        resolved: 'green',
      };
      const color = statusColorMap[this.initialStatus];

      this.selectedStatuses = color ? [color] : [];
      this.updateIssuesFilter();
    },
    // ---- helper para construir el parámetro y llamar al backend ----
    updateIssuesFilter() {
      const allIssues = Array.isArray(this.store) ? this.store : [];

      // Si no hay filtros, mostramos todo
      if (!this.selectedStatuses.length) {
        this.filteredIssues = allIssues;
        return;
      }

      // Si hay filtros, filtramos por color seleccionado
      this.filteredIssues = allIssues.filter((issue) =>
        this.selectedStatuses.includes(
          this.getComplaintStatusTone(issue)
        )
      );
    },
    toggleStatus(color, element) {
      const idx = this.selectedStatuses.indexOf(color);
      if (idx === -1) {
        this.selectedStatuses.push(color);
        element.classList.add('show-icon');
        element.classList.remove('hide-icon');
      } else {
        this.selectedStatuses.splice(idx, 1);
        element.classList.remove('show-icon');
        element.classList.add('hide-icon');
      }
      this.updateIssuesFilter();
    },
    onToolbarPreparing(e) {
      const toolbarItems = e.toolbarOptions.items;
      e.toolbarOptions.elementAttr = {
        class: 'custom-toolbar toolbar-complaint-management',
      };
      toolbarItems.forEach((item) => {
        if (item.name === 'searchPanel') {
          item.location = 'before';
        }
      });

      // Añadir el selector de agrupaciones
      toolbarItems.push({
        name: 'Pendiente de gestion',
        location: 'before',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: this.$t('pendingManagement'),
          icon: '././static/icons/ic_check.svg',
          width: 210,
          elementAttr: {
            class: `filtrosBotones ${
              this.selectedStatuses.includes('orange')
                ? 'show-icon'
                : 'hide-icon'
            }`,
          },
          onClick: (ev) => {
            this.toggleStatus('orange', ev.element);
          },
        },
      });

      toolbarItems.push({
        name: 'En gestion',
        location: 'before',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: this.$t('inManagement'),
          icon: '././static/icons/ic_check.svg',
          width: 190,
          elementAttr: {
            class: `filtrosBotones ${
              this.selectedStatuses.includes('blue')
                ? 'show-icon'
                : 'hide-icon'
            }`,
          },
          onClick: (ev) => {
            this.toggleStatus('blue', ev.element);
          },
        },
      });

      toolbarItems.push({
        name: 'Resueltas',
        location: 'before',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: this.$t('resolved'),
          icon: '././static/icons/ic_check.svg',
          width: 190,
          elementAttr: {
            class: `filtrosBotones ${
              this.selectedStatuses.includes('green')
                ? 'show-icon'
                : 'hide-icon'
            }`,
          },
          onClick: (ev) => {
            this.toggleStatus('green', ev.element);
          },
        },
      });
      // El listado y el detalle son de solo lectura para empleados AGQ.
      // El boton de alta solo existe para contactos habilitados con permiso
      // de registro; no basta con poder consultar incidencias.
      if (this.canRegisterComplaints) {
        toolbarItems.push({
          location: 'after',
          widget: 'dxButton',
          locateInMenu: 'never',
          options: {
            text: this.$t('complaintRequest'),
            elementAttr: {
              class: 'botones-registrar',
            },
            onClick: () => {
              this.GoRegisterComplaint();
            },
          },
        });
      }
    },
    loadState() {
      let state = localStorage.getItem('ComplaintsTable');
      if (state) {
        state = JSON.parse(state);
        state.searchText = '';
      }
      return state;
    },
    GoRegisterComplaint() {
      if (!this.canRegisterComplaints) {
        return;
      }

      this.$f7router.navigate(
        {
          name: 'ComplaintRegister',
        },
        {
          animate: true,
          transition: 'f7-fade',
        }
      );
    },
    customSave(state) {
      localStorage.setItem('ComplaintsTable', JSON.stringify(state));
    },
    getComplaintStatusTone(issue) {
      const toneByStatus = {
        pending_action: 'orange',
        in_progress: 'blue',
        resolved: 'green',
      };
      const normalizedStatus = String(
        issue?.status || issue?.estado || ''
      )
        .toLowerCase()
        .trim();
      const normalizedColor = String(issue?.color || '')
        .toLowerCase()
        .trim();

      if (toneByStatus[normalizedStatus]) {
        return toneByStatus[normalizedStatus];
      }

      const toneByColor = {
        red: 'orange',
        orange: 'orange',
        yellow: 'blue',
        blue: 'blue',
        green: 'green',
      };

      return toneByColor[normalizedColor] || 'grey';
    },
    getComplaintStatusClass(issue) {
      const tone = this.getComplaintStatusTone(issue);

      return `complaint-issue-status complaint-issue-status--${tone}`;
    },
    init(e) {
      // this.setComplaints(e.component.getDataSource().items());
      this.grid = e;
      this.loaded = true;
    },
    async viewAtc(e) {
      this.setSampleFetchedFromEtl(false);
      this.setLastRouteHome(false);
      this.setLastRouteGeotoolboxSamples(false);

      // Mostramos el preloader
      this.loaded = false;

      // Las incidencias no verdes no tienen informe de respuesta.
      if (e.row.data.color !== 'green') {
        this.setComplaintReport([]);
      }

      // Definimos una lista de promesas con los métodos que cargan datos
      const backgroundPromises = [
        this.fetchComplaintFilesZip({
          codigoIncidencia: e.row.data.title,
        }),
      ];

      // Si la incidencia está cerrada o finalizada (color verde), añadimos también la descarga del informe de contestación
      if (e.row.data.color === 'green') {
        backgroundPromises.push(
          this.fetchComplaintReportZip({
            codigoIncidencia: e.row.data.title,
          })
        );
      }

      Promise.all(backgroundPromises).catch((error) => {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error)
            ),
            width: 550,
          },
          'error'
        );
      });

      try {
        await this.fetchComplaintDetails({
          selectedComplaint: e.row.data,
        });
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error)
            ),
            width: 550,
          },
          'error'
        );
      } finally {
        // Ocultamos el preloader
        this.loaded = true;
      }

      // Redirección de la ruta (fuera del await para que sea inmediata)
      this.replaceCurrent({
        name: this.$t('complaintManagementDetails'),
        disabled: false,
        page: 'ComplaintManagementDetails',
        active: true,
      });

      this.$f7router.navigate(
        { name: 'ComplaintManagementDetails' },
        {
          animate: true,
          transition: 'f7-fade',
        }
      );
    },

    ...mapActions('complaintManagement', [
      'setComplaints',
      'fetchComplaintList',
      'fetchComplaintDetails',
      'fetchComplaintFilesZip',
      'fetchComplaintReportZip',
      'setComplaintReport',
    ]),
    ...mapActions('breadcrumb', ['replaceCurrent']),
    ...mapActions('samples', [
      'setSampleFetchedFromEtl',
      'setLastRouteHome',
      'setLastRouteGeotoolboxSamples',
    ]),
  },
};
</script>
<style lang="scss">
@import './complaintManagement.styles.scss';
</style>
